<div>
  <dx-button
    stylingMode="text"
    [icon]="'fas fa-book'"
    (onClick)="onButtonClick()"
    hint="Go to the wiki"
  />
</div>
